import cn from 'clsx';
import { forwardRef, HTMLAttributes, useContext, FC } from 'react';

import { TextButtonModel } from '../../../types';
import TextButton from '../../Button/Text';
import AccordionIcon from '../AccordionIcon';
import AccordionContext from '../context';

import s from './FoldAccordionButton.module.scss';

export interface FoldAccordionButtonProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
  button?: TextButtonModel;
}

const FoldAccordionButton: FC<FoldAccordionButtonProps> = forwardRef<HTMLDivElement, FoldAccordionButtonProps>(
  ({ title, description, button, ...rest }, ref) => {
    const FoldAccordionButtonContext = useContext(AccordionContext);

    return (
      <div className={s['click-area']} ref={ref} {...rest} onClick={FoldAccordionButtonContext?.onClick}>
        <AccordionIcon size={20} />
        <div className={cn(s.wrapper, s['only-title'])}>
          <h1 className={s.title}>
            {title}
            {button && (
              <TextButton className={s.button} state={button.state} size="small" icon={button.icon} onClick={button.onClick}>
                {button.label}
              </TextButton>
            )}
          </h1>
          {description && <p className={s.description}>{description}</p>}
        </div>
      </div>
    );
  }
);

export default FoldAccordionButton;
